import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauDenumeroterAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	private isRejet: boolean;

	constructor(options: BaseLiquidationOptions & { isRejet?: boolean } = null) {
		super(options);
		this.label = options?.isRejet
			? 'Annuler l’archivage de ce bordereau de rejet'
			: 'Dénuméroter';
		this.type = BordereauActionType.DENUMEROTER;
		this.isRejet = options?.isRejet;
	}

	execute = (
		_bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauDenumeroterModal: {
				visible: true,
				isArchive: this.isRejet,
			},
		},
	});

	/**
	 * Bordereau déjà dénuméroté par le job que la modale a lancé et suivi (BordereauDenumeroterModal), relu avec ses
	 * journaux : il remplace celui de l'arbre.
	 */
	executeAction = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.UPDATE,
		result: Promise.resolve(bordereau),
		shouldRefreshChildren: true,
	});
}

export default BordereauDenumeroterAction;
